'use strict';
const state = {
  path: ''
};

const mutations = {
  SavePath(state, val) {
    state.path = val
  },
}

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/path.js